<script>
import CMExamConfig from '../../classes/CMExamConfig'
export default {
  render() {
    return this.$scopedSlots.default({
      formData: this.formData,
      updateFormData: this.updateFormData
    })
  },
  data: () => ({
    formData: new CMExamConfig()
  }),
  methods: {
    updateFormData(data) {
      this.formData = {
        ...this.formData,
        ...data
      }
    }
  }
}
</script>
